export const theme = {
  colors: {
    primary400: 'var(--primary-400)',
    primary500: 'var(--primary-500)',
    primary600: 'var(--primary-600)',
    primaryText: 'var(--primary-text)',
    secondary400: 'var(--secondary-400)',
    secondary500: 'var(--secondary-500)',
    secondary600: 'var(--secondary-600)',
    subtle400: 'var(--subtle-400)',
    subtle500: 'var(--subtle-500)',
    subtle600: 'var(--subtle-600)',
    error400: 'var(--error-400)',
    error500: 'var(--error-500)',
    error600: 'var(--error-600)',
    success400: 'var(--success-400)',
    success500: 'var(--success-500)',
    success600: 'var(--success-600)',
    warning400: 'var(--warning-400)',
    warning500: 'var(--warning-500)',
    warning600: 'var(--warning-600)',
    onPrimary400: 'var(--on-primary-400)',
    onPrimary500: 'var(--on-primary-500)',
    onPrimary600: 'var(--on-primary-600)',
    onSecondary400: 'var(--on-secondary-400)',
    onSecondary500: 'var(--on-secondary-500)',
    onSecondary600: 'var(--on-secondary-600)',
    onBackground: 'var(--on-background)',
    onSurface: 'var(--on-surface)',
    onSubtle: 'var(--on-subtle)',
    onSurfaceLight: 'var(--on-surface-light)',
    onSurfaceLighter: 'var(--on-surface-lighter)',
    onSurfaceBorder: 'var(--on-surface-border)',
    onField: 'var(--on-field)',
    onError400: 'var(--on-error-400)',
    onError500: 'var(--on-error-500)',
    onError600: 'var(--on-error-600)',
    onWarning400: 'var(--on-warning-400)',
    onWarning500: 'var(--on-warning-500)',
    onWarning600: 'var(--on-warning-600)',
    fontSizeSmall: 'var(--font-size-s)',
    fontSizeMedium: 'var(--font-size-m)',
    fontSizeLarge: 'var(--font-size-l)',
    background: 'var(--background)',
    surface: 'var(--surface)',
    glassEdge: 'var(--glass-edge)',
    shadowShort1: 'var(--shadow-short-1)',
    shadowShort2: 'var(--shadow-short-2)',
  },
  /** Spacing scale. Use these for padding, margins and gaps rather than ad hoc values. */
  space: {
    xs: 'var(--space-1, 4px)',
    s: 'var(--space-2, 8px)',
    m: 'var(--space-3, 12px)',
    l: 'var(--space-4, 16px)',
    xl: 'var(--space-5, 24px)',
    xxl: 'var(--space-6, 32px)',
  },
  /** Shared control metrics, so buttons, inputs and selects line up in a row. */
  sizes: {
    control: 'var(--control-height, 32px)',
    controlSmall: 'var(--control-height-s, 26px)',
    radius: 'var(--radius, 4px)',
  },
};
